import {
    COLLEGE_LIST_REQUEST,
    COLLEGE_LIST_SUCCESS,
    COLLEGE_LIST_FAIL,
    COLLEGE_LIST_RESET,
    COLLEGE_LIST_TOTAL_REQUEST,
    COLLEGE_LIST_TOTAL_SUCCESS,
    COLLEGE_LIST_TOTAL_FAIL,
    COLLEGE_LIST_TOTAL_RESET,
    COLLEGE_CREATE_REQUEST,
    COLLEGE_CREATE_SUCCESS,
    COLLEGE_CREATE_FAIL,
    COLLEGE_GET_REQUEST,
    COLLEGE_GET_SUCCESS,
    COLLEGE_GET_FAIL,
    COLLEGE_UPDATE_SUCCESS,
    COLLEGE_UPDATE_REQUEST,
    COLLEGE_UPDATE_FAIL,
    COLLEGE_DELETE_REQUEST,
    COLLEGE_DELETE_SUCCESS,
    COLLEGE_DELETE_FAIL,
    COLLEGE_CREATE_RESET,
    COLLEGE_UPDATE_RESET,
    COLLEGE_GET_RESET
} from '../constants/collegeConstants'

export const collegeListReducer = (state = { colleges: [] }, action) => {
    switch (action.type) {
        case COLLEGE_LIST_REQUEST:
            return { loading: true };
        case COLLEGE_LIST_SUCCESS:
            return { loading: false, colleges: action.payload }
        case COLLEGE_LIST_FAIL:
            return { loading: false, error: action.payload, colleges: [] }
        case COLLEGE_LIST_RESET:
            return { loading: false, state: {} }
        default:
            return state;
    }
}

export const collegeListTotalReducer = (state = { collegeTotal: "" }, action) => {
    switch (action.type) {
        case COLLEGE_LIST_TOTAL_REQUEST:
            return { loading: true };
        case COLLEGE_LIST_TOTAL_SUCCESS:
            return { loading: false, collegeTotal: action.payload }
        case COLLEGE_LIST_TOTAL_FAIL:
            return { loading: false, error: action.payload }
        case COLLEGE_LIST_TOTAL_RESET:
            return { loading: false, state: {} }
        default:
            return state;
    }
}

export const collegeCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case COLLEGE_CREATE_REQUEST:
            return { loading: true };
        case COLLEGE_CREATE_SUCCESS:
            return { loading: false, success: action.payload }
        case COLLEGE_CREATE_FAIL:
            return { loading: false, error: action.payload }
        case COLLEGE_CREATE_RESET:
            return { loading: false, success: '' }
        default:
            return state;
    }
}

export const collegeDetailsReducer = (state = { college: [] }, action) => {
    switch (action.type) {
        case COLLEGE_GET_REQUEST:
            return { loading: true };
        case COLLEGE_GET_SUCCESS:
            return { loading: false, college: action.payload }
        case COLLEGE_GET_FAIL:
            return { loading: false, error: action.payload }
        case COLLEGE_GET_RESET:
            return { college:[] }
        default:
            return state;
    }
}

export const collegeUpdateReducer = (state = {}, action) => {
    switch (action.type) {
        case COLLEGE_UPDATE_REQUEST:
            return { loading: true };
        case COLLEGE_UPDATE_SUCCESS:
            return { loading: false, success: action.payload }
        case COLLEGE_UPDATE_FAIL:
            return { loading: false, error: action.payload }
        case COLLEGE_UPDATE_RESET:
            return { loading: false, success: '' }
        default:
            return state;
    }
}

export const collegeDeleteReducer = (state = {}, action) => {
    switch (action.type) {
        case COLLEGE_DELETE_REQUEST:
            return { loading: true };
        case COLLEGE_DELETE_SUCCESS:
            return { loading: false, success: action.payload }
        case COLLEGE_DELETE_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state;
    }
}



